import React, { useEffect, useMemo, useState } from "react";

import HelplyLanding from "./App";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import DataDeletionPolicyPage from "./pages/DataDeletionPolicyPage";

function getRouteFromHash(hash) {
  // We only treat hashes that start with "#!/" as routes.
  // This preserves the landing page section anchors like "#features".
  if (!hash || !hash.startsWith("#!/")) return { kind: "home" };

  const path = hash.slice(2); // remove "#!"
  if (path === "/" || path === "") return { kind: "home" };
  if (path === "/terms") return { kind: "terms" };
  if (path === "/privacy") return { kind: "privacy" };
  if (path === "/data-deletion") return { kind: "data-deletion" };

  return { kind: "not-found" };
}

export default function RouterApp() {
  const [hash, setHash] = useState(() => window.location.hash);

  useEffect(() => {
    const onHashChange = () => setHash(window.location.hash);
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  const route = useMemo(() => getRouteFromHash(hash), [hash]);

  switch (route.kind) {
    case "terms":
      return <TermsOfServicePage />;
    case "privacy":
      return <PrivacyPolicyPage />;
    case "data-deletion":
      return <DataDeletionPolicyPage />;
    case "not-found":
      return (
        <div className="min-h-screen bg-white text-slate-800">
          <div className="max-w-3xl mx-auto px-6 py-16">
            <a
              href="#!/"
              className="text-sm font-semibold text-blue-600 hover:text-blue-700"
            >
              ← Back to Home
            </a>
            <h1 className="mt-6 text-3xl font-extrabold text-slate-900">
              Page not found
            </h1>
            <p className="mt-3 text-slate-600">
              This page doesn’t exist. Please use the footer links to find the
              legal pages.
            </p>
          </div>
        </div>
      );
    case "home":
    default:
      return <HelplyLanding />;
  }
}


